import creditCardType from 'credit-card-type';
import min from 'lodash/min';
import map from 'lodash/map';
import get from 'lodash/get';

/**
 * Validate card number, by default should allow only Visa and Mastercard
 * types are available here: https://github.com/braintree/credit-card-type
 *
 * @param num
 * @param types
 */
export enum CardTypeType {
  Visa = 'visa',
  Mastercard = 'mastercard',
  AmericanExpress = 'american-express',
}

/**
 * Return user friendly card type label.
 * @param cardType
 */
export const getCardTypeLabel = (cardType: CardTypeType) => {
  switch (cardType) {
    case CardTypeType.AmericanExpress:
      return 'American Express';
    case CardTypeType.Mastercard:
      return 'Master Card';
    case CardTypeType.Visa:
      return 'Visa';
  }
};

export const VALID_CVC_LENGTH = Object.freeze({
  [CardTypeType.Visa]: 3,
  [CardTypeType.Mastercard]: 3,
  [CardTypeType.AmericanExpress]: 4,
});

/**
 * Return valid CVC length for given card number
 * @param cardNumber
 */
export const getCVCLengthForCardNumber = (cardNumber: string) => {
  const cardTypes = creditCardType(cardNumber);
  return min(map(cardTypes, (cardType) => Number(get(cardType, 'code.size', 3))));
};

/**
 * Get card type from card number
 * @param cardNumber
 */
export const getCardTypeFromCardNumber = (cardNumber: string) => {
  const cardTypes = creditCardType(cardNumber);
  return cardTypes[0]?.type;
};
